import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

import { BaseInputValidatorDirective } from './base-input-validator.directive';
import { CardNumberUtils } from '../_appCommon/cardNumber/cardNumberUtils';
import { CommonRegex } from '../_appCommon/base/Constants';

@Directive({
  selector: '[openpayCardNumber]'
})

export class OpenPayCardNumberDirective extends BaseInputValidatorDirective
{
  protected input: HTMLInputElement;

  @Output()
  protected onCardNumber: EventEmitter<string>;

  constructor(protected elementRef: ElementRef)
  {
    super();

    this._el = elementRef;

    this.input = this.elementRef.nativeElement as HTMLInputElement;
    this.onCardNumber = new EventEmitter<string>();

    this._regex = CommonRegex.OpenPayCardNumber;
  }

  @HostListener('keyup')
  public onKeyUp(): boolean
  {
    let cardNumber: string = CardNumberUtils.unmask(this.input.value);
    let cardNumberMask = CardNumberUtils.mask(cardNumber);

    this.input.value = cardNumberMask;
    this.onCardNumber.emit(cardNumber);

    if (!CardNumberUtils.isValidLength(cardNumber))
    {
      return false;
    }

    return true;
  }


}
